import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import Chat from './pages/Chat';
import SignUp from './pages/SignUp';
import PaymentSuccess from './pages/PaymentSuccess';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { useAuth } from './context/AuthContext'; // Import useAuth
import GlobalErrorHandler from './components/GlobalErrorHandler';
import FirebaseErrorHandler from './components/FirebaseErrorHandler';
import InstagramBrowserDetector from './components/InstagramBrowserDetector';
import './firebase'; // Initialize Firebase

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth(); // Use context state

  // Optional: Add logging for clarity
  useEffect(() => {
    // console.log(`ProtectedRoute: isLoading=${isLoading}, isAuthenticated=${isAuthenticated}`);
  }, [isLoading, isAuthenticated]);

  if (isLoading) {
    // Show loading indicator while initial auth check is happening
    return <div className="min-h-screen flex items-center justify-center">Loading Auth...</div>;
  }
  
  // Check if we're in full mode or landing page mode
  const isFullMode = process.env.REACT_APP_APP_MODE === 'full';
  
  if (!isAuthenticated && isFullMode) {
    console.log('ProtectedRoute: Not authenticated in full mode, redirecting to /');
    // Redirect to login if not authenticated (according to our app state)
    return <Navigate to="/" replace />; 
  }
  
  console.log('ProtectedRoute: Authenticated, rendering children');
  // Render the requested component if authenticated
  return children; 
};

function App() {
  // AuthProvider is now in index.js
  return (
    <InstagramBrowserDetector>
      <Router>
        <div className="min-h-screen bg-gray-100">
          <GlobalErrorHandler />
          <FirebaseErrorHandler />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancelled" element={<PaymentSuccess />} />
            <Route path="/payment/error" element={<PaymentSuccess />} />
            {/* Ensure only the protected route exists */}
            <Route
              path="/chat"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </Router>
    </InstagramBrowserDetector>
  );
}

export default App;
